import { styled } from "sharedUI/styles";
import { disabledProps } from "webapp/styled-components";

export const GlideDropdownWrapper = styled.div<{ isEnabled: boolean }>`
    position: relative;

    font-size: 12px;
    line-height: 16px;

    margin: 8px 0;

    &.slim {
        margin: 0;
    }

    color: ${p => p.theme.fgColorMedium};

    display: flex;
    flex-direction: column;
    .highlight-container > * {
        background-color: ${p => p.theme.dropdownButton.bgColor};
    }

    .no-border > * {
        border-radius: 0;
    }
    ${p => !p.isEnabled && disabledProps}
`;

export const DropdownLabel = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
`;

export const IconWrapper = styled.a`
    margin: 4px 0 0 4px;
    width: 14px;
    height: 14px;
    color: ${p => p.theme.fgColorLight};
    cursor: pointer;

    :hover {
        color: ${p => p.theme.fgColorDark};
    }
`;
